import classNames from "classnames";
import colors from '../../config/colors.json';
import rgbHex from 'rgb-hex';

let unit_pbgid = require("../../config/all-unified-techs.json")

function getIconByPbgid(pbgid) {
  for (const units of Object.values(unit_pbgid)) {
    const match = units.find(unit => unit.pbgid === pbgid);
    if (match) return match.icon;
  }
  return null; // not found
}


export function LiveGameKeyTech({ tech, currentUpgrades, color }) {
  const upgrades = Object.values(currentUpgrades || [])?.filter(upgrade => tech.requiredUpgrades?.includes(parseInt(upgrade)));
  const hasImproved = Object.values(currentUpgrades || [])?.filter(upgrade => tech.improved === parseInt(upgrade));

  if (!color) return;
  let mainColor = rgbHex(colors[color]?.mainColor) || 'white';

  let rounded = tech.maxTechs === 6 ? 'mx-[0.5px] rounded-sm liveGameOverlay__macedonianKeyTechDot' : 'mx-[1px] rounded-lg'

  return (
    <div className={classNames("w-[40px] h-[53px] flex flex-col mx-[2px]")}>
      <div className="w-[40px] relative" style={{ backgroundImage: `url(/liveGameIcons/tech_background.png)` }}>
        <img className="w-10 h-10" src={tech.icon} alt="" />
      </div>
      <div className="mt-[2px] flex flex-row justify-center">
        {/* For the length of required upgrades make a dot stroke-[#5E6989]*/}
        {Array.from({ length: tech.maxTechs || 0 }).map((_, index) => (
          <div key={index} className={classNames(rounded, `outline-[#5E6989] outline-[0.5px] w-9 h-[9px] z-10`)}
            style={{
              outlineStyle: "solid",
              backgroundColor: upgrades[index] ? `#${mainColor}` : "#2E2E2E"
            }}></div>
        ))}
      </div>
      {tech.improved &&
      <div className="absolute flex flex-row justify-center mt-9 mx-auto w-10">
        <div key={"improvedMongols"} className={classNames(rounded, `outline-[#5E6989] outline-[0.5px] w-8 h-[7px]`)}
          style={{
            outlineStyle: "solid",
            backgroundColor: hasImproved[0] ? `#${mainColor}` : "#2E2E2E"
          }}></div>
      </div>}
    </div>
  );
}
